const css = `.calendar-toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  gap: 8px;
  flex-wrap: wrap;
}
.calendar-toolbar .toolbar-navigation {
  display: flex;
  align-items: center;
  gap: 4px;
}
.calendar-toolbar .toolbar-navigation button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: var(--border-radius);
  padding: 0;
}
.calendar-toolbar .toolbar-navigation button:hover {
  background-color: var(--surface-hover);
}
.calendar-toolbar .toolbar-navigation .toolbar-label {
  font-weight: var(--font-weight-semibold);
  min-width: 120px;
  text-align: center;
}
.calendar-toolbar .toolbar-content {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.calendar-toolbar .toolbar-content .toolbar-summary {
  display: flex;
  gap: 8px;
  flex: 1;
}
.calendar-toolbar .toolbar-content .toolbar-summary .summary-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: var(--border-radius);
  background-color: var(--surface-ground);
  font-size: var(--font-size-xs);
  white-space: nowrap;
}
.calendar-toolbar .toolbar-content .toolbar-summary .summary-item.highlight {
  background-color: var(--accent-subtle);
  color: var(--accent);
}
.calendar-toolbar .toolbar-content .toolbar-summary .summary-item i {
  font-size: var(--font-size-sm);
}
.calendar-toolbar .toolbar-content .toolbar-summary .summary-item i.success {
  color: var(--success);
}
.calendar-toolbar .toolbar-content .toolbar-summary .summary-item i.warning {
  color: var(--warning);
}
.calendar-toolbar .toolbar-content .toolbar-summary .summary-item i.error {
  color: var(--danger);
}
.calendar-toolbar .toolbar-content .toolbar-views {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
@media screen and (max-width: 650px) {
  .calendar-toolbar {
    flex-direction: column;
    padding: 8px 4px;
  }
  .calendar-toolbar .toolbar-navigation {
    justify-content: center;
    width: 100%;
  }
  .calendar-toolbar .toolbar-navigation .toolbar-label {
    min-width: 100px;
    font-size: var(--font-size-sm);
  }
  .calendar-toolbar .toolbar-navigation .p-button {
    padding: 8px 12px;
    font-size: var(--font-size-xs);
  }
  .calendar-toolbar .toolbar-navigation .p-button .p-button-icon {
    font-size: var(--font-size-xs);
  }
  .calendar-toolbar .toolbar-content {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .calendar-toolbar .toolbar-content .toolbar-summary {
    justify-content: center;
  }
  .calendar-toolbar .toolbar-content .toolbar-summary .summary-item {
    font-size: var(--font-size-xs);
    padding: 4px 8px;
  }
  .calendar-toolbar .toolbar-content .toolbar-summary .summary-item i {
    font-size: var(--font-size-xs);
  }
  .calendar-toolbar .toolbar-content .toolbar-views {
    justify-content: center;
    width: 100%;
  }
  .calendar-toolbar .toolbar-content .toolbar-views .p-button {
    padding: 8px 12px;
    font-size: var(--font-size-xs);
  }
  .calendar-toolbar .toolbar-content .toolbar-views .p-button .p-button-icon {
    font-size: var(--font-size-xs);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
